import logo from "./ICON-05.png";
import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import CatalogListing from "./Pages/CatalogListing";
import CategoryCatalogListing from "./Pages/CategoryCatalogListing";
import CatalogDetails from "./Pages/CatalogDetails";
import Footer from "./components/Footer";
import ContactUs from "./Pages/ContactUs";
import About from "./Pages/About";
import Blogs from "./Pages/Blogs";
import Login from "./Pages/admin/Login";
import Dashboard from "./Pages/admin/Dashboard";
import Appointment from "./Pages/admin/Appointment";
import CatalogForm from "./Pages/admin/CatalogForm";
import BlogForm from "./Pages/admin/BlogForm";
import CatalogIndex from "./Pages/admin/CatalogIndex";
import CategoryIndex from "./Pages/admin/CategoryIndex";
import BlogIndex from "./Pages/admin/BlogIndex";
import CatalogEdit from "./Pages/admin/CatalogEdit";
import BlogEdit from "./Pages/admin/BlogEdit";
import BlogDetail from "./Pages/BlogDetail";
import Collections from "./Pages/Collections";

function App() {
  return (
    <div className="App">
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalog-listing" element={<CatalogListing />} />
            <Route path="/collections" element={<Collections />} />
            <Route
              path="/categories/:slug"
              element={<CategoryCatalogListing />}
            />
            <Route path="/catalog-details/:slug" element={<CatalogDetails />} />
            <Route path="/footer" element={<Footer />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blogs />} />
            <Route path="/blog-details/:slug" element={<BlogDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Dashboard />} />
            <Route path="/admin/appointments" element={<Appointment />} />
            <Route path="/admin/catalog/create" element={<CatalogForm />} />
            <Route path="/admin/catalog/edit/:slug" element={<CatalogEdit />} />
            <Route path="/admin/catalogs" element={<CatalogIndex />} />
            <Route path="/admin/blogs" element={<BlogIndex />} />
            <Route path="/admin/blog/create" element={<BlogForm />} />
            <Route path="/admin/blog/edit/:slug" element={<BlogEdit />} />
            <Route path="/admin/categories" element={<CategoryIndex />} />
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App;
